import React from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Card,
  Image,
  CardBody,
  Heading,
  Stack,
  CardFooter,
  Link,
  UnorderedList,
  ListItem
} from "@chakra-ui/react";
import LanguageTag from "./LanguageTag";
import DollyZoomPDF from "../../documents/Computational_Dolly_Zoom_2023.pdf";


interface PortfolioProps {
  title: string;
  desc: string;
  link: string | null;
  linkLabel: string | null;
  role: string | null;
  tags: string[];
  image: string | null;
  bullets: [string, string][];
  activeIdx: number;
  setActiveIdx: React.Dispatch<React.SetStateAction<number>>;
}

export default function PortfolioItem(props: PortfolioProps) {
  function handleLinkClick(){
    if (props.link == "DollyZoomPDF") return DollyZoomPDF
    else if (props.link) return props.link
    return ""
  }
    return (
      <Card
        direction="column"
        alignItems={"center"}
        justifyContent="flex-start"
        variant="none"
        width={"90%"}
        height="85%"
        borderLeftRadius="1rem"
        borderRightRadius={{ base: "1rem", lg: "0rem" }}
        my="1rem"
        backgroundColor="offwhiteOpacity"
        backdropFilter="auto"
        backdropBlur="5px"
        border="lightgrey solid 1px"
        borderRight={{ base: "lightgrey solid 1px", lg: "none" }}
        py={{ lg: "2rem", base: "1rem" }}
        px={{ lg: "3rem", base: "2rem" }}
        gap="1rem"
        overflowY="scroll"
      >
        <Flex
          width="100%"
          flexDir={{ base: "row", lg: "column" }}
          justifyContent={{ base: "flex-start", lg: "center" }}
          alignItems={{ base: "center", lg: "flex-start" }}
          gap=".5rem"
        >
          <Text variant={"tinyHeader"}>{props.title}</Text>
          <Link href={handleLinkClick()} target="_blank">
            <Button
              variant="outlineSmall"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              display={props.linkLabel ? "flex" : "none"}
            >
              {props.linkLabel}
            </Button>
          </Link>
        </Flex>
        <Flex width="100%">
          <Flex height="100%" width="40%" flexDir="column" gap="1rem">
            <Image
              objectFit="contain"
              src={props.image ? props.image : ""}
              borderRadius={"1rem"}
              key={Date.now()}
            />
            <Text variant="type" color="mediumgrey">
              {props.role ? "Role:" + props.role : ""} <br></br>
              Languages:
            </Text>
            <Flex flexDir="row" wrap="wrap" gap=".5rem">
              {props.tags.map((t, key) => (
                <LanguageTag lang={t} key={key}></LanguageTag>
              ))}
            </Flex>
          </Flex>
          <Flex height="100%" width="60%" flexDir="column" pl="2rem">
            <Text variant="type">{props.desc}</Text>
            <br></br>
            <Text variant="typeBold" color="darkblue">
              <b>Key Features</b>
            </Text>
            <br></br>
            <Text variant="type">
              <UnorderedList>
                {props.bullets.map((b) => (
                  <ListItem>
                    {b[0] ? <b>{b[0]}</b> : ""}
                    {b[1]&& b[0] ? <b>{" → "}</b> : ""}
                    {b[1] ? b[1] : ""}
                  </ListItem>
                ))}
              </UnorderedList>
            </Text>
          </Flex>
        </Flex>
      </Card>
    );
}